class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.min = 0;
    this.max = 1000;
    this.currentMin = 0;
    this.currentMax = 1000;
    this.isDragging = false;
    this.currentSlider = null;
  }

  connectedCallback() {
    // Ottieni i valori dal dataset
    this.min = parseFloat(this.dataset.min || '0');
    this.max = parseFloat(this.dataset.max || '1000');
    this.currentMin = parseFloat(this.dataset.currentMin || this.min);
    this.currentMax = parseFloat(this.dataset.currentMax || this.max);
    
    // Se currentMin è NaN o uguale a min, usa min
    if (isNaN(this.currentMin) || this.currentMin <= this.min) {
      this.currentMin = this.min;
    }
    
    // Se currentMax è NaN o uguale a max, usa max
    if (isNaN(this.currentMax) || this.currentMax >= this.max) {
      this.currentMax = this.max;
    }
    
    // Ottieni i nomi dei parametri per il form
    this.minParamName = this.dataset.minParam || 'filter.v.price.gte';
    this.maxParamName = this.dataset.maxParam || 'filter.v.price.lte';
    
    this.form = this.closest('form');

    this.render();
  }

  getCurrencySymbol() {
    if (this.dataset.currency) return this.dataset.currency;

    // Prova a ottenere il simbolo della valuta dal shop
    const shopCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (shopCurrency === 'EUR') return '€';
    if (shopCurrency === 'USD') return '$';
    if (shopCurrency === 'GBP') return '£';
    if (shopCurrency === 'PLN') return 'zł';

    // Default
    return '€';
  }

  render() {
    const currencySymbol = this.getCurrencySymbol();
    
    // Determina se impostare i valori iniziali
    const minValue = this.currentMin > this.min ? this.currentMin : '';
    const maxValue = this.currentMax < this.max ? this.currentMax : '';
    
    this.innerHTML = `
      <div class="cc-price-range">
        <!-- Input nascosti per il form -->
        <input 
          type="hidden" 
          name="${this.minParamName}" 
          class="cc-price-range__input cc-price-range__input--min" 
          value="${minValue}"
        >
        <input 
          type="hidden" 
          name="${this.maxParamName}" 
          class="cc-price-range__input cc-price-range__input--max" 
          value="${maxValue}"
        >
        
        <div class="cc-price-range__bar">
          <div class="cc-price-range__bar-inactive"></div>
          <div class="cc-price-range__bar-active"></div>
          <div class="cc-price-range__control cc-price-range__control--min" data-type="min">
            <span class="cc-price-range__value cc-price-range__value--min">${currencySymbol}${Math.round(this.currentMin)}</span>
          </div>
          <div class="cc-price-range__control cc-price-range__control--max" data-type="max">
            <span class="cc-price-range__value cc-price-range__value--max">${currencySymbol}${Math.round(this.currentMax)}</span>
          </div>
        </div>
      </div>
    `;
    
    this.bindEvents();
    this.updateBar();
  }

  bindEvents() {
    const minControl = this.querySelector('.cc-price-range__control--min');
    const maxControl = this.querySelector('.cc-price-range__control--max');
    
    // Mouse events
    minControl.addEventListener('mousedown', (e) => this.startDrag(e, 'min'));
    maxControl.addEventListener('mousedown', (e) => this.startDrag(e, 'max'));
    
    // Touch events
    minControl.addEventListener('touchstart', (e) => this.startDrag(e, 'min'), { passive: false });
    maxControl.addEventListener('touchstart', (e) => this.startDrag(e, 'max'), { passive: false });
    
    // Global events
    document.addEventListener('mousemove', (e) => this.drag(e));
    document.addEventListener('mouseup', () => this.stopDrag());
    document.addEventListener('touchmove', (e) => this.drag(e), { passive: false });
    document.addEventListener('touchend', () => this.stopDrag());
  }

  startDrag(e, type) {
    e.preventDefault();
    this.isDragging = true;
    this.currentSlider = type;
    
    const bar = this.querySelector('.cc-price-range__bar');
    this.barRect = bar.getBoundingClientRect();
    this.barWidth = bar.offsetWidth;
  }

  drag(e) {
    if (!this.isDragging) return;
    
    e.preventDefault();
    const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    const offsetX = clientX - this.barRect.left;
    const percent = Math.max(0, Math.min(100, (offsetX / this.barWidth) * 100));
    
    const value = this.min + (percent / 100) * (this.max - this.min);
    
    if (this.currentSlider === 'min') {
      this.currentMin = Math.min(value, this.currentMax - 1);
      // Se il valore minimo è uguale al minimo del range, imposta a 0 o al valore minimo
      if (Math.abs(this.currentMin - this.min) < 1) {
        this.currentMin = this.min;
      }
    } else {
      this.currentMax = Math.max(value, this.currentMin + 1);
      // Se il valore massimo è uguale al massimo del range, imposta al valore massimo
      if (Math.abs(this.currentMax - this.max) < 1) {
        this.currentMax = this.max;
      }
    }
    
    this.updateBar();
    this.updateInputs();
  }

  stopDrag() {
    if (this.isDragging) {
      this.isDragging = false;
      this.currentSlider = null;
      this.submitForm();
    }
  }

  updateBar() {
    const minPercent = ((this.currentMin - this.min) / (this.max - this.min)) * 100;
    const maxPercent = ((this.currentMax - this.min) / (this.max - this.min)) * 100;
    
    const activeBar = this.querySelector('.cc-price-range__bar-active');
    const minControl = this.querySelector('.cc-price-range__control--min');
    const maxControl = this.querySelector('.cc-price-range__control--max');
    const minValue = this.querySelector('.cc-price-range__value--min');
    const maxValue = this.querySelector('.cc-price-range__value--max');
    
    const currencySymbol = this.getCurrencySymbol();
    
    if (activeBar) {
      activeBar.style.left = `${minPercent}%`;
      activeBar.style.width = `${maxPercent - minPercent}%`;
    }
    
    if (minControl) {
      minControl.style.left = `${minPercent}%`;
    }
    
    if (maxControl) {
      maxControl.style.left = `${maxPercent}%`;
    }
    
    // Aggiorna i valori visualizzati
    if (minValue) {
      minValue.textContent = `${currencySymbol}${Math.round(this.currentMin)}`;
    }
    
    if (maxValue) {
      maxValue.textContent = `${currencySymbol}${Math.round(this.currentMax)}`;
    }
  }

  updateInputs() {
    const minInput = this.querySelector('.cc-price-range__input--min');
    const maxInput = this.querySelector('.cc-price-range__input--max');
    
    if (minInput) {
      // Imposta il valore solo se diverso dal minimo
      if (Math.round(this.currentMin) > this.min) {
        minInput.value = Math.round(this.currentMin);
      } else {
        minInput.value = ''; // Svuota il campo se è al valore di default
      }
    }
    
    if (maxInput) {
      // Imposta il valore solo se diverso dal massimo
      if (Math.round(this.currentMax) < this.max) {
        maxInput.value = Math.round(this.currentMax);
      } else {
        maxInput.value = ''; // Svuota il campo se è al valore di default
      }
    }
  }

  submitForm() {
    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      if (this.form) {
        // Aggiorna gli input prima di inviare il form
        this.updateInputs();
        
        const formData = new FormData(this.form);
        const params = new URLSearchParams();

        for (const [key, value] of formData.entries()) {
          if (value && value !== '') {
            // Per il price range, invia i valori solo se sono diversi dai default
            if (key === this.minParamName) {
              const numValue = parseFloat(value);
              // Invia solo se diverso dal minimo
              if (!isNaN(numValue) && numValue > this.min) {
                params.append(key, numValue.toString());
              }
            } else if (key === this.maxParamName) {
              const numValue = parseFloat(value);
              // Invia solo se diverso dal massimo
              if (!isNaN(numValue) && numValue < this.max) {
                params.append(key, numValue.toString());
              }
            } else {
              params.append(key, value);
            }
          }
        }
        
        const currentParams = new URLSearchParams(window.location.search);
        for (const [key, value] of currentParams.entries()) {
          if (!params.has(key) && key !== 'page') {
            params.append(key, value);
          }
        }
        
        const baseUrl = window.location.pathname;
        const queryString = params.toString();
        const newUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        window.location.href = newUrl;
      }
    }, 500);
  }

  updateRange(newMin, newMax) {
    if (typeof newMin !== 'number' || typeof newMax !== 'number') return;
    if (newMax <= newMin) return;

    // Arrotonda per avere valori puliti sullo slider
    newMin = Math.floor(newMin);
    newMax = Math.ceil(newMax);

    // Se il range non è cambiato, non fare nulla
    if (newMin === this.min && newMax === this.max) return;

    const oldMin = this.min;
    const oldMax = this.max;

    this.min = newMin;
    this.max = newMax;

    // Regola currentMin/currentMax se sono fuori dal nuovo range
    if (this.currentMin <= oldMin || this.currentMin < newMin) {
      this.currentMin = newMin;
    }
    if (this.currentMax >= oldMax || this.currentMax > newMax) {
      this.currentMax = newMax;
    }

    // Aggiorna i data attributes per coerenza
    this.dataset.min = String(newMin);
    this.dataset.max = String(newMax);

    // Re-render la barra e i valori
    this.updateBar();
    this.updateInputs();
  }
}

customElements.define('price-range', PriceRange);